import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';
import InlineInputNumber from '../inputs/InlineInputNumber';


const StaleScriptRule = (props) => {
  const {
    form, type, onSubmit, initialValues, ...other
  } = props;
  const [numberDays, setNumberDays] = useState(initialValues.number_days || 3);

  const submit = useCallback((event) => {
    event.preventDefault();
    onSubmit({
      kind: 'stale_script',
      value: {
        number_days: numberDays
      }
    });
  }, [numberDays, onSubmit]);

  const onReset = useCallback(() => {
    setNumberDays(initialValues.number_days || 3);
  }, [initialValues.number_days]);


  return (
    <RuleForm
      {...other}
      onSubmit={submit}
      onReset={onReset}
      isSubmitting={form.is_submitting}
    >
      <InlineInputNumber
        label='Number of Days'
        description='Must be between 1-7'
        value={numberDays}
        onChange={setNumberDays}
      />
    </RuleForm>
  );
};

StaleScriptRule.defaultProps = {
  type: 'add',
  initialValues: {
    number_days: 3
  }
};

StaleScriptRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default StaleScriptRule;
